
export class WareHouseProConfig {

    constructor() {
        this.WarehousePro = false;
        this.RemarkConfigurationForShipmentType = null;
        this.RemarkConfigurationForShipmentTime = null;
        this.RemarkConfigurationForDeliveryPoint = null;
    }

    WarehousePro?: boolean;
    RemarkConfigurationForShipmentType?: any;
    RemarkConfigurationForShipmentTime?: any;
    RemarkConfigurationForDeliveryPoint?:any;
}

